export type IMaskPosteNumbers = IDCA.IGenericFunc;

export function _maskPosteNumbers(): void {
  $('input.poste-field').each((_, input) => {
    const $input = $(input);
    const mask = $input.data('field-mask') || '00000-0000';
    ($input as any).mask(mask);
  });
}
